import * as React from 'react';
const SvgFire = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 20 23" fill="none" {...props}>
        <path
            d="M3.319 20.431a7.985 7.985 0 003.342 1.662c.118.039.197-.115.118-.192-2.634-2.514-1.187-5.234-.118-6.46.763-.876 1.848-2.318 1.77-4.252 0-.193.197-.348.353-.232 1.495.773 2.517 2.475 2.792 3.867.434-.425.59-1.083.59-1.662 0-.194.236-.35.433-.194 1.416 1.276 3.854 5.607-.079 9.009-.078.078 0 .233.08.195a9.635 9.635 0 003.303-1.587c6.41-4.95 2.24-13.728-.473-16.627-.354-.349-.983-.117-.983.386-.04 1.045-.354 2.204-1.179 2.978-.63-2.63-2.726-5.616-5.714-7.085-.393-.194-.865.115-.825.54.077 3.598-2.27 5.888-4.315 8.866-1.81 2.667-2.988 7.579.905 10.788z"
            fill="currentColor"
        />
    </svg>
);
export default SvgFire;
